function changeBG() {

    // console.log('changeBG initialized');
    const blocks = document.querySelectorAll('.cta_center, .cta_large');

    blocks.forEach(block => {
        const number = block.classList[2].split('--')[1];
        let previousBlock = document.querySelector('.block--' + (parseInt(number) - 1));
        let nextBlock = document.querySelector('.block--' + (parseInt(number) + 1));

        let bgColorPrevious = '';
        let bgColorNext = '';

        if (previousBlock) {
            bgColorPrevious = previousBlock.style['background'];
        }

        if (nextBlock) {
            bgColorNext = nextBlock.style['background'];
        }

        let linearGradient = 'linear-gradient(to bottom, ' + (previousBlock ? bgColorPrevious + ' 50%' : '#fff 50%') + ', ' + (nextBlock ? bgColorNext + ' 50%' : '#fff 50%') + ')';

        block.style['background'] = linearGradient;
    });

}

export default changeBG;

